import type { Transition } from "motion/react";

export const slideVariants = {
  enter: (direction: number) => ({
    x: direction > 0 ? "30%" : "-30%",
    opacity: 0,
  }),
  center: {
    x: 0,
    opacity: 1,
  },
  exit: (direction: number) => ({
    x: direction > 0 ? "-30%" : "30%",
    opacity: 0,
  }),
};

export const SLIDE_TRANSITION: Transition = {
  duration: 0.25,
  ease: [0.32, 0.72, 0, 1],
};
